import { render, staticRenderFns } from "./joinWelcomeModal.vue?vue&type=template&id=0c34c734&scoped=true"
import script from "./joinWelcomeModal.vue?vue&type=script&lang=js"
export * from "./joinWelcomeModal.vue?vue&type=script&lang=js"
import style0 from "./joinWelcomeModal.vue?vue&type=style&index=0&id=0c34c734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34c734",
  null
  
)

export default component.exports